module.exports = __webpack_public_path__ + "static/media/1POLICY38.8e2c7f92.jpg";